import {
  FormTab,
  AudienceRestrictionField,
  getPageTypeFormFields,
} from 'app/modules/posts/modules/detail/modules/audienceRestrictions/constants/audienceRestrictions';
import {
  AudienceRestrictions,
  AudienceRestrictionsOptions,
} from 'app/modules/posts/types/AudienceRestrictionsOptions';

function isValidValue(val: unknown): boolean {
  return val !== '' && val != null && val !== undefined;
}

export function hasAudienceRestrictionValue(value: unknown): boolean {
  if (Array.isArray(value)) {
    return value.length > 0 && value.some(isValidValue);
  }

  return isValidValue(value);
}

export function getFormFields(pageType: number, formTab: FormTab) {
  const pageTypeFormFields = getPageTypeFormFields();
  return pageTypeFormFields[formTab][pageType] ?? [];
}

export function convertOptionsToValues(
  restrictions: Partial<AudienceRestrictionsOptions>,
): AudienceRestrictions {
  return Object.fromEntries(
    Object.entries(restrictions)
      .map(([field, options]) => {
        const mappedValue = Array.isArray(options)
          ? options.map((option) => option.value)
          : options.value;

        if (
          field === 'age_min' &&
          Array.isArray(mappedValue) &&
          mappedValue.length > 0
        ) {
          return [field, mappedValue[0]];
        }

        return [field, mappedValue];
      })
      .filter(([field, value]) => {
        return hasAudienceRestrictionValue(value);
      }),
  );
}

export function createCompleteFormState(
  mappedValues: Partial<AudienceRestrictionsOptions>,
): AudienceRestrictionsOptions {
  const result = {} as AudienceRestrictionsOptions;

  Object.values(AudienceRestrictionField).forEach((field) => {
    result[field] = mappedValues[field] || [];
  });

  return result;
}

export function createCompleteAudienceRestrictions(
  audienceRestrictions: Partial<AudienceRestrictions>,
): AudienceRestrictions {
  const result = {} as AudienceRestrictions;

  Object.values(AudienceRestrictionField).forEach((field) => {
    result[field] = audienceRestrictions[field] || [];
  });

  return result;
}

export function countActiveAudienceRestrictions(
  audienceRestrictions: AudienceRestrictions | null | undefined,
): number {
  let count = 0;

  if (!audienceRestrictions) {
    return count;
  }

  Object.values(audienceRestrictions).forEach((restrictionValue) => {
    if (hasAudienceRestrictionValue(restrictionValue)) {
      count++;
    }
  });

  return count;
}
